import { memo } from "react";
import Svg, { Path, type SvgProps } from "react-native-svg";

const SvgCalendar = (props: SvgProps) => (
  <Svg fill="none" height={25} width={24} {...props}>
    <Path d="M10 15.5H6v4h4z" fill={props.color} />
    <Path
      clipRule="evenodd"
      d="M7.125.5C6.504.5 6 1.004 6 1.625V2.5H4a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3v-16a3 3 0 0 0-3-3h-2.75v-.875a1.125 1.125 0 1 0-2.25 0V2.5H8.25v-.875C8.25 1.004 7.746.5 7.125.5M15 7.375V4.75H8.25v2.625a1.125 1.125 0 0 1-2.25 0V4.75H4a.75.75 0 0 0-.75.75v5h17.5v-5a.75.75 0 0 0-.75-.75h-2.75v2.625a1.125 1.125 0 1 1-2.25 0M3.25 21.5v-9h17.5v9a.75.75 0 0 1-.75.75H4a.75.75 0 0 1-.75-.75"
      fill={props.color}
      fillRule="evenodd"
    />
  </Svg>
);
const Memo = memo(SvgCalendar);
export default Memo;
